import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSchema } from "@/contexts/contact";
import { Box } from "@gemini/core";
import { useFormContext } from "react-hook-form";
import { getFeaturesEnabled } from "@/utils";
import { useState } from "react";
import { useTrackingFormInteraction } from "@/hooks/tracking/useTrackingFormInteraction";
import { contactFormFieldsTestId } from "../ContactForm/ContactFormFields/constants";
import { MessageInput } from "../ContactForm/ContactFormFields/MessageInput";
import { SaveSearchOptIn } from "../ContactForm/SaveSearchOptIn";
import { contactFormTestId } from "../ContactForm/constants";
import { useIsSavedSearchEnabled } from "../hooks/useIsSavedSearchEnabled";
import { SaveSearchOptInDE } from "../ContactForm/SaveSearchOptInDE";
export const CompactContactFormFields = ({ contactFormDatas, tracking, }) => {
    const { control } = useFormContext();
    const { trackFormInteraction } = useTrackingFormInteraction(tracking);
    const gap = "spacing.16";
    const { message } = useSchema().shape;
    const handleFormFieldInteraction = () => {
        trackFormInteraction();
    };
    const [hasSearchParameters] = useState(false);
    const { savedSearchOptIn } = getFeaturesEnabled();
    const isSavedSearchTestEnabled = useIsSavedSearchEnabled();
    const isSaveSearchOptInEnabledFR = savedSearchOptIn && hasSearchParameters;
    const isSaveSearchOptInEnabledDE = isSavedSearchTestEnabled && hasSearchParameters;
    return (_jsxs(Box, { testId: contactFormFieldsTestId, display: "flex", flexDirection: "column", gap: gap, onFocus: handleFormFieldInteraction, children: [_jsx(MessageInput, { control: control, required: !message.isOptional(), contactFormDatas: contactFormDatas }), isSaveSearchOptInEnabledDE || isSaveSearchOptInEnabledFR ? (_jsx(Box, { children: isSaveSearchOptInEnabledDE ? (_jsx(SaveSearchOptInDE, { control: control, testId: contactFormTestId })) : (_jsx(SaveSearchOptIn, { control: control, required: false, testId: contactFormTestId, isSaveSearchOptInEnabled: isSaveSearchOptInEnabledFR })) })) : null] }));
};
